import React from 'react';
import { useToriBottomBannerDisplay } from './ToriBottomBannerDisplay';

export function ToriFiltersBottomMarker() {
    const { filterListBottomRef } = useToriBottomBannerDisplay();

    return (
        <div
            id="advertising-tori-filters-bottom-marker"
            ref={filterListBottomRef}
        />
    );
}
